import React from 'react';
import PropTypes from 'prop-types';
import stylePropType from 'react-style-proptype';

import { comparisonOptionType } from '../proptypes/comparison-options';
import carouselType from '../proptypes/carousel';
import phrasesType from '../proptypes/phrases';
import { Chevron } from './UiIcons';
import CarouselIndicator from './CarouselIndicator';
import { ssColorCyan } from '../constants/style-constants';

const ComparisonBarChartHeader = ({
  layers, style, comparison, rotateComparison, carousel, phrases,
}) => {
  const jumpTo = (index) => {
    rotateComparison(index - carousel.selected);
  };
  const showCarousel = carousel?.total > 1;

  return (
    <div className="row comparison-bar-chart-header" style={style}>
      {showCarousel && (
        <button
          type="button"
          className="comparison-bar-chart-header__rotate comparison-bar-chart-header__rotate--left"
          onClick={() => rotateComparison(-1)}
        >
          <Chevron width={27} height={45} color={ssColorCyan} rotate={180} />
          <span className="ss-screen-reader-only">{phrases.previous}</span>
        </button>
      )}
      <div className="col-12">
        <h4 className="comparison-bar-chart-header__self" style={{ color: layers[0].color }}>{layers[0].name}</h4>
        <div className="comparison-bar-chart-header__vs"><span style={style}>vs</span></div>
        <h4>
          <span className="comparison-bar-chart-header__other" style={{ color: layers[1].color }}>{comparison.name}</span>
          <span className="comparison-bar-chart-header__other-spy-role" style={{ color: layers[0].color }}>{comparison.spyRole}</span>
        </h4>
        {showCarousel && <CarouselIndicator {...carousel} onClick={jumpTo} />}
      </div>
      {showCarousel && (
        <button
          type="button"
          className="comparison-bar-chart-header__rotate comparison-bar-chart-header__rotate--right"
          onClick={() => rotateComparison(1)}
        >
          <span className="ss-screen-reader-only">{phrases.next}</span>
          <Chevron width={27} height={45} color={ssColorCyan} />
        </button>
      )}
    </div>
  );
};

ComparisonBarChartHeader.propTypes = {
  layers: PropTypes.arrayOf(PropTypes.object).isRequired,
  style: stylePropType.isRequired,
  comparison: comparisonOptionType.isRequired,
  rotateComparison: PropTypes.func.isRequired,
  carousel: carouselType.isRequired,
  phrases: phrasesType.isRequired,
};

export default ComparisonBarChartHeader;
